// extracted by mini-css-extract-plugin
export default {"modal-body":"QdHSoD08Psk3gbWT2WIKZw=="};